import React from "react";
import { View, Image, YStack, Button } from "tamagui";
import TextCoustom, { TextSize } from "@components/TextCoustom";
import { colors } from "@styles/colors";
import * as basicStyle from "@styles/index";

const OrderNotFoundImg = require("@styles/images/order_not_found.png") as string;

const DEFAULT_TITLE = "找不到草稿訂單";
const DEFAULT_DESCRIPTION =
  "此訂單可能已被取消、過期或連結不正確，請返回草稿列表重新選擇。";

type DraftNotFoundViewProps = {
  onBackToDrafts: () => void;
  title?: string;
  description?: string;
  buttonText?: string;
  imageUri?: string;
  imageAlt?: string;
};

/**
 * 找不到草稿訂單 / 訂單無法修改時的統一區塊。
 * 編輯訂單、快速修改配送時間頁共用。風格與 Welcome / Settings 頁一致。
 */
export default function DraftNotFoundView({
  onBackToDrafts,
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  buttonText = "返回草稿列表",
  imageUri = OrderNotFoundImg,
  imageAlt = "找不到訂單",
}: DraftNotFoundViewProps) {
  return (
    <View flex={1} w="100%" bg="#FFF" px="$7" py="$4" justifyContent="center">
      <YStack alignItems="center" w="100%" gap="$4">
        {/* Image */}
        <View w="100%" h={280} alignItems="center" justifyContent="center">
          <Image
            source={{ uri: imageUri }}
            alt={imageAlt}
            w="100%"
            h="100%"
            resizeMode="contain"
          />
        </View>

        {/* Text */}
        <YStack gap="$2" alignItems="center">
          <TextCoustom
            type={TextSize.SUBHEADING}
            str={title}
            color={colors.dakerBlue}
            bold
          />
          {description ? (
            <TextCoustom
              type={TextSize.NORMAL}
              str={description}
              others={{ textAlign: "center", maxWidth: 320 }}
            />
          ) : null}
        </YStack>

        {/* Button */}
        <View w="100%" mt="$4">
          <Button
            onPress={onBackToDrafts}
            {...basicStyle.ShareBlueButton}
            className="primary-bg-gradient"
            color="#FFF"
            size="$5"
            w="100%"
          >
            {buttonText}
          </Button>
        </View>
      </YStack>
    </View>
  );
}
